import React from 'react';
import PropTypes from 'prop-types';
import { Common } from '../../utils/common';

function PerformanceSummaryWidget({
  color,
  title,
  value,
  secondaryContent,
  chart,
  delta,
  isPercentage = false,
  invertChangeColor = false,
}) {
  const change = delta > 0 ? 'increase' : 'decrease';
  let changeColor = change;
  if (invertChangeColor) {
    changeColor = change === 'increase' ? 'decrease' : 'increase';
  }

  return (
    <div className={`performance_summary_widget_container ${color}_border`}>
      <div className={`performance_summary_widget_header ${color}_background`}>{title}</div>
      <div className='performance_summary_widget_content'>
        <div className={`performance_summary_widget_stats ${changeColor}_color`}>
          <div className='performance_summary_widget_value'>
            {isPercentage ? `${value}%` : Common.formatNumberWithCommas(value)}
          </div>
          <i
            className={`performance_summary_widget_arrow fa fa-arrow-${
              change === 'increase' ? 'up' : 'down'
            }`}
          ></i>
          <div className='performance_summary_widget_subtext'>
            {Math.abs(delta)}
            {isPercentage ? '%' : ''} {change === 'increase' ? 'Up' : 'Down'} vs. Last Month
          </div>
        </div>
        <div className='performance_summary_widget_secondary_content'>{secondaryContent}</div>
        <div className='performance_summary_widget_chart_container'>{chart}</div>
      </div>
    </div>
  );
}

PerformanceSummaryWidget.propTypes = {
  color: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.PropTypes.number.isRequired,
  secondaryContent: PropTypes.node,
  chart: PropTypes.node.isRequired,
  delta: PropTypes.number.isRequired,
  isPercentage: PropTypes.bool,
  invertChangeColor: PropTypes.bool,
};

export default PerformanceSummaryWidget;
